<script setup lang="ts">
import type {PropType} from "vue";
import {converterCurrencies, getSignFromQuote, supportedQuoteCurrencies} from "@consts";
import {formatCurrency} from "@lib/formatCurrencyNumbers.ts";

const props = defineProps({
  close: {
    type: Number as PropType<number | undefined>,
    required: false,
    default: undefined
  },
  priceChange24h: {
    type: Number as PropType<number | undefined>,
    required: false,
    default: undefined
  },
  priceChange7d: {
    type: Number as PropType<number | undefined>,
    required: false,
    default: undefined
  },
  vwap: {
    type: Number as PropType<number | undefined>,
    required: false,
    default: undefined
  },
  baseVolume: {
    type: Number as PropType<number | undefined>,
    required: false,
    default: undefined
  },
  quoteVolume: {
    type: Number as PropType<number | undefined>,
    required: false,
    default: undefined
  },
  quote: { type: String, required: true },
  crypto: { type: String, required: true },

  quoteName: { type: String, required: true },
  cryptoName: { type: String, required: true },
});

const sign = getSignFromQuote(props.quote)


</script>

<template>
  <div class="crypto-info">
    <p class="leading-relaxed">
      {{ $t('current_price_info', { crypto, price: formatCurrency(close,sign), change24h: priceChange24h, change7d: priceChange7d }) }}
      {{ $t('circulating_supply_info', { crypto, marketCap: formatCurrency(vwap,sign) }) }}
      {{ $t('trading_volume_info', { volume: formatCurrency(baseVolume,sign) }) }}
    </p>
    <p class="leading-relaxed mt-4">
      {{ $t('conversion_rate_calculation') }}
      {{ $t('exchange_rate_update', { crypto, quote }) }}
    </p>
    <p class="leading-relaxed mt-4">
      {{ $t('follow_dipsway_info', { crypto, currencies: supportedQuoteCurrencies.slice(0,10).join(', ') }) }}
    </p>
  </div>
</template>

<style scoped>
.crypto-info {
  color: white;
  font-size: 1rem;
  line-height: 1.5;
  background-color: rgba(255, 255, 255, 0.02);
  padding: 1.5rem;
  border-radius: 8px;
}
</style>
